import dayjs from 'dayjs';
import { useMemo, useState } from 'react';
import { Button } from '../../../../../../components/button/button';
import { Modal } from '../../../../../../components/modal/modal';
import { TextArea } from '../../../../../../components/textarea/textarea';
import { validate } from '../../../../../../helpers/validate';
import { useLang } from '../../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../../hooks/use-query-params';
import { useCheckInCheckOutStore } from '../../../../../../store/use-check-in-check-out-store';
import { CheckingTimeInput } from '../check-in-check-out-edit-modal/check-in-time-input/checking-time-input';
import { findCheckIn } from '../check-in-check-out-helpers';
import s from './check-in-check-out-delete-modal.module.css';

export const CheckInCheckOutDeleteModal = () => {
  const { t } = useLang();
  const { checkins, isLoadingFetch, deleteCheckin } = useCheckInCheckOutStore();

  const { addQueryParams, getQueryParams } = useQueryParams();
  const params = getQueryParams();
  const id = params.deleteId;

  const checkin = useMemo(() => findCheckIn(checkins || [], id), [id, checkins]);

  const [reason, setReason] = useState('');

  const handleClose = () => {
    addQueryParams({
      deleteId: undefined,
    });
  };

  const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();

    try {
      const isValid = validate({
        reason: { rule: () => !!reason },
      });

      if (!isValid) return;

      await deleteCheckin(id, reason);
      handleClose();
      setReason('');
    } catch (error) {
      console.error(error);
    }
  };

  const isOpen = !!id;

  if (!isOpen) return null;

  return (
    <Modal
      className={s.feature}
      title={t('Вы действительно хотите удалить сеанс?')}
      onClose={handleClose}
    >
      <div className={s.form}>
        <div className={s.inputs}>
          <CheckingTimeInput
            label={t('Приход')}
            date={dayjs(checkin?.start_time)}
            time={dayjs(checkin?.start_time)}
            newDate={dayjs(checkin?.end_time)}
            newTime={checkin?.end_time ? dayjs(checkin?.end_time).format('HH:mm') : ''}
            name="start_time"
            disabled={true}
          />
        </div>

        <TextArea
          name="reason"
          placeholder={t('Причина')}
          value={reason}
          onChange={(e) => setReason(e.currentTarget.value)}
          disabled={isLoadingFetch}
        />
      </div>

      <div className={s.controls}>
        <Button variant="danger" onClick={handleSubmit} disabled={isLoadingFetch}>
          {t('Удалить')}
        </Button>
      </div>
    </Modal>
  );
};
